import React, { useState } from "react";
import {
  IconChevronRight,
  IconPaperclip,
  IconCaretDownFilled,
} from "@tabler/icons-react";
import ReCAPTCHA from "react-google-recaptcha"; // Import reCAPTCHA

const Contactus = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedService, setSelectedService] = useState("Select service");
  const [recaptchaValue, setRecaptchaValue] = useState(null); // State to hold reCAPTCHA value

  const handleSelect = (service) => {
    setSelectedService(service);
    setIsOpen(false);
  };

  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value); // Store reCAPTCHA response value
  };

  return (
    <div>
      <section className="mt-[71px] bg-[url(../images/banner-bg.png)] bg-cover bg-no-repeat md:mt-[87px] xl:mt-0">
        <div className="bg-opacity-40 py-[52px]">
          <div className="container text-n8">
            <h3 className="h3 mb-2.5">Contact Us</h3>
            <ul className="flex flex-wrap items-center gap-2">
              <li>
                <a href="/" className="home-link">
                  Home
                </a>
              </li>
              <li className="flex items-center">
                <IconChevronRight size={24} />
              </li>
              <li>
                <a href="/contact" className="home-link">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>
     
      <section className="section bg-gray-100 py-12 md:py-20">
        <div className="container">
          {/* Header Section */}
          <div className="mx-auto mb-5 max-w-[921px] text-center lg:mb-[60px]" data-aos="fade-right">
            <h5 className="h5 mb-3 font-semibold text-[#006DB2] tracking-wide">
              Got a Question?
            </h5>
            <h3 className="h3 mb-3 text-4xl font-bold text-gray-800 leading-tight">
              We Are Here to Answer It!
            </h3>
          </div>

          <div className="grid grid-cols-12 items-center gap-6 border rounded shadow">
            {/* Form Section */}
            <div className="col-span-12 lg:col-span-6" data-aos="fade-right">
              <form
                className="rounded-2xl px-2 py-6 sm:px-3 md:py-8"
                style={{ backgroundColor: "#42a3b3b8" }}
              >
                <div className="grid grid-cols-2 gap-3">
                  <div className="col-span-2 md:col-span-1">
                    <input
                      type="text"
                      placeholder="Name*"
                       className="bg-white text-black w-full rounded-[30px] border border-n5 px-6 py-2 text-n8 focus:border-n7 focus:outline-none"
                      required
                    />
                  </div>
                  <div className="col-span-2 md:col-span-1">
                    <input
                      type="number"
                      placeholder="Phone*"
                       className="bg-white text-black w-full rounded-[30px] border border-n5 px-6 py-2 text-n8 focus:border-n7 focus:outline-none"
                      required
                    />
                  </div>
                  <div className="col-span-2 md:col-span-1">
                    <input
                      type="email"
                      placeholder="Email*"
                       className="bg-white text-black w-full rounded-[30px] border border-n5 px-6 py-2 text-n8 focus:border-n7 focus:outline-none"
                      required
                    />
                  </div>
                  <div className="col-span-2">
                    <textarea
                      name="message"
                      id="message"
                      placeholder="Let us know what you need"
                      rows="3"
                      className="bg-white text-black w-full rounded-[30px] border border-n5 px-6 py-2 text-n8 focus:border-n7 focus:outline-none"
                    ></textarea>
                  </div>
                  {/* Remove Terms checkbox and replace with reCAPTCHA */}
                  <div className="col-span-2 text-n8 mb-4">
                    <ReCAPTCHA
                      sitekey="6LdVJ-QqAAAAAHkwIGNsMrHo4LTW1DN0sg9RgvH0" // Replace with your reCAPTCHA site key
                      onChange={handleRecaptchaChange} // Handle the value change
                    />
                  </div>
                  <div className="col-span-2 mt-3 flex justify-center md:mt-5">
                    <button 
                      className="btn border-white px-10 bg-white text-black"
                      disabled={!recaptchaValue} // Disable submit button if reCAPTCHA is not checked
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>

            {/* Contact Links with Animation */}
            <div className="col-span-12 lg:col-span-6" data-aos="fade-left">
              <ul className="space-y-4">
                <li className="mb-3">
                  <a
                    className=" list-item group flex items-center justify-between transition-all duration-300 p-4 rounded-lg"
                    href="#"
                  >
                    <div>
                      <h4 className="h4 mb-2 text-title">Book a Demo</h4>
                      <p className="text-para">
                        with our engagement specialist
                      </p>
                    </div>
                    <span
                      className="arrow-icon flex-shrink-0 text-white"
                      style={{ backgroundColor: "#42a3b3b8" }}
                    >
                      <IconChevronRight size={24} />
                    </span>
                  </a>
                </li>
                <li>
                  <a
                    className="list-item group flex items-center justify-between transition-all duration-300 p-4 rounded-lg"
                    href="#"
                  >
                    <div>
                      <h4 className="h4 mb-2 text-title">Send Your CV</h4>
                      <p className="text-para">if you want to join your team</p>
                    </div>
                    <span
                      className="arrow-icon flex-shrink-0 text-white"
                      style={{ backgroundColor: "#42a3b3b8" }}
                    >
                      <IconChevronRight size={24} />
                    </span>
                  </a>
                </li>
                <li>
                  <a
                    className="list-item group flex items-center justify-between transition-all duration-300 p-4 rounded-lg"
                    href="mailto:support@mail.com"
                  >
                    <div>
                      <h4 className="h4 mb-2 text-title">Reach Us via Email</h4>
                      <p className="text-primary">support@mail.com</p>
                    </div>
                    <span
                      className="arrow-icon flex-shrink-0 text-white"
                      style={{ backgroundColor: "#42a3b3b8" }}
                    >
                      <IconChevronRight size={24} />
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="contact__area">
        <div className="container mb-5" data-aos="zoom-in">
          <div className="contact-map">
            {/* <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d234129.8677368368!2d78.24323260275466!3d17.412281015798097!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb99daeaebd2c7%3A0xae93b78392bafbc2!2sHyderabad%2C%20Telangana!5e1!3m2!1sen!2sin!4v1740995946814!5m2!1sen!2sin" 
              height="500"
              style={{ border: "0", width: "100%" }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe> */}
            <iframe src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d6730.404505598899!2d77.21668349264934!3d28.629789302664452!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1s5th%20Floor%2C%20Wing-A%2C%20Statesman%20House%2C%20Barakhamba%20Road%2C%20New%20Delhi%20-%20110001!5e1!3m2!1sen!2sin!4v1742826290734!5m2!1sen!2sin" height="500"
              style={{ border: "0", width: "100%" }}  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Contactus;
